import { useState } from "react";
// =========== css =============
import "./signup.css";
//================  other assets ================
import CustomInput from "Utills/CustomInput/CustomInput";
import profileIcon from "assets/Images/icons/profile.svg";
import emailIcon from "assets/Images/icons/email.svg";
import lockIcon from "assets/Images/icons/lock.svg";
import CalendarIcon from "assets/Images/icons/Calendar.svg";
// import fbIcon from "assets/Images/icons/fb-icon.svg"
// import googleIcon from "assets/Images/icons/google-icon.svg"
//============ components ================
import { Paper, Button } from "@material-ui/core";
import CustomButton from "Utills/Button/CustomButton";
import CustomModel from "Utills/Model/CustomModel";
import { Calendar } from "react-date-range";
import { useNotifyContext } from "context/notifyContext";
import SiginInPopup from "Components/Popup/SiginInPopup/SiginInPopup";
import ReactFlagsSelect from "react-flags-select";
import { Redirect } from "react-router-dom";
// ============== functions etc ============
import { check_current_user } from "store/actions";
import { connect } from "react-redux";
import axios from "axios";
import Moment from "moment";
import Loader from "Components/others/Loader";
import { Helmet } from "react-helmet";
//

// api endpoints
let api_users = process.env.REACT_APP_API_USERS;

//
const SignUp = (props) => {
  // notification
  const { set_notify, loader, set_loader } = useNotifyContext();
  // State for login Modal
  const [showPopup, setShowPopup] = useState(false);
  // State for Birthdate Calendar Modal
  const [openCalendar, setOpenCalendar] = useState(false);
  // Form data state
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    confirm_password: "",
    date_of_birth: "",
    nationality: "",
    captain: false,
    sailor: true,
  });

  // send form details to sign Up a new user with their required details
  const send_signUp = async (e) => {
    e.preventDefault();
    set_loader(true);
    let data = {
      name: formData.first_name,
      surname: formData.last_name,
      email: formData.email,
      password: formData.password,
      country: formData.nationality,
      captain: formData.captain ? "true" : "false",
      sailor: formData.sailor ? "true" : "false",
      birthdate: Moment(formData?.date_of_birth).format("YYYY-MM-DD"),
    };
    axios({
      method: "POST",
      url: api_users,
      data: data,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8", // "text/html; charset=UTF-8",
      },
    })
      .then((response) => {
        let data = response?.data;
        if (data.status !== "error") {
          localStorage.setItem("cyan_user", JSON.stringify(data.token));
          set_loader(false);
          set_notify({
            open: true,
            msg: "Sign Up Successfully.",
            type: "success",
          });
          setFormData({
            first_name: "",
            last_name: "",
            email: "",
            password: "",
            confirm_password: "",
            date_of_birth: "",
            nationality: "",
            captain: false,
            sailor: false,
          });
          props.check_current_user(data.token);
        } else {
          set_loader(false);
          set_notify({
            open: true,
            msg: data?.["error-message"],
            type: "error",
          });
          console.log("Error about sign up to new user ====>", data);
        }
      })
      .catch((err) => {
        set_loader(false);
        set_notify({ open: true, msg: err.message, type: "error" });
        console.log("Error about sign up to new user ====>", err.message);
      });
  };

  //================== check date is valid or not should be 18 or greater ======================
  function underAgeValidate(birthday) {
    // it will accept two types of format yyyy-mm-dd and yyyy/mm/dd
    var optimizedBirthday = birthday?.toString()?.replace(/-/g, "/");

    //set date based on birthday at 01:00:00 hours GMT+0100 (CET)
    var myBirthday = new Date(optimizedBirthday);

    // set current day on 01:00:00 hours GMT+0100 (CET)
    var currentDate = new Date().toJSON().slice(0, 10) + " 01:00:00";

    // calculate age comparing current date and borthday
    var myAge = ~~((Date.now(currentDate) - myBirthday) / 31557600000);

    if (myAge < 18) {
      return false;
    } else {
      return true;
    }
  }

  // Handle form detail on change
  const handleFormDetails = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  //============================== check if user is already logged in if yes then redirect to profile page instead of sign up again ==========================
  if (props.current_user && props.current_user?.isAuth) {
    return <Redirect push to="/" />;
  } else if (props.current_user?.isLoading) {
    return (
      <div className="sign_up_page py-5">
        <Helmet>
          <title>Cyan | Signup</title>
        </Helmet>
        <div className="container  py-5 mt-5">
          <div className="col-12 my-5 py-5">
            <div className="pt-3 pb-4 px-3 signup_form_wrapper mx-auto">
              <Loader />
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="sign_up_page">
      <Helmet>
        <title>Cyan | Signup</title>
      </Helmet>
      <div className="container-lg">
        <Paper className="pt-3 pb-4 px-3 signup_form_wrapper mx-auto">
          {/* form started */}
          <form action="" onSubmit={send_signUp}>
            <div className="row text-center">
              <div className="col-12 mx-auto px-md-3 p-2">
                {/* top sec */}
                <div className="top_mode_btns mb-2 d-flex mx-auto justify-content-center">
                  <CustomButton
                    onClick={() =>
                      setFormData({
                        ...formData,
                        sailor: true,
                        captain: false,
                      })
                    }
                    size={"large"}
                    startIcon={
                      <svg
                        width="35"
                        height="35"
                        viewBox="0 0 49 50"
                        fill="none"
                      >
                        <path
                          d="M39.4916 25.0994C39.3467 24.8926 39.1101 24.7694 38.8576 24.7694H32.5836C30.8247 23.1659 28.5077 22.2477 26.0849 22.2477H21.177C21.5916 21.8547 22.1494 21.6228 22.7549 21.6228H26.0598C26.4067 21.6228 26.7112 21.3921 26.8049 21.0581C26.8988 20.7242 26.7589 20.3686 26.4628 20.188C24.1154 18.7567 21.4215 18 18.6721 18H15.5541C13.8836 18 12.3743 19.0536 11.7984 20.6217C11.7112 20.8591 11.7455 21.1241 11.8903 21.3316C12.035 21.539 12.272 21.6625 12.525 21.6625H14.3955L11.2118 28.5679C10.5723 28.942 9.94496 29.342 9.33181 29.7691C9.12392 29.9137 9 30.151 9 30.4042V33.226C9 33.6534 9.34652 34 9.77399 34H27.8861C30.4542 34 32.9235 33.2214 35.027 31.7484C37.1306 30.2754 38.7067 28.2213 39.5849 25.8081C39.6712 25.5708 39.6365 25.3063 39.4916 25.0994ZM27.8861 32.452H10.548V30.8121C14.9105 27.8703 19.9885 26.3175 25.2598 26.3175H37.6897C35.8821 30.0282 32.073 32.452 27.8861 32.452ZM16.3074 21.2126C16.4178 20.973 16.3986 20.6936 16.2564 20.4713C16.1141 20.2491 15.8684 20.1146 15.6045 20.1146H13.9889C14.4205 19.7572 14.9713 19.5481 15.5541 19.5481H18.6721C19.9533 19.5481 21.2211 19.7313 22.4389 20.0875C20.8726 20.2135 19.5455 21.27 19.0799 22.7959C19.0083 23.0305 19.0522 23.2851 19.1982 23.4822C19.3441 23.6795 19.5749 23.7957 19.8202 23.7957H26.0849C27.4434 23.7957 28.762 24.14 29.9281 24.7695H25.2599C21.1416 24.7695 17.1349 25.6647 13.4617 27.3853L16.3074 21.2126Z"
                          fill="#3F8BBF"
                        />
                        <path
                          d="M24.5786 28.4717H22.2857C21.8582 28.4717 21.5117 28.8183 21.5117 29.2457C21.5117 29.6731 21.8582 30.0197 22.2857 30.0197H24.5786C25.0061 30.0197 25.3526 29.6731 25.3526 29.2457C25.3526 28.8183 25.0061 28.4717 24.5786 28.4717Z"
                          fill="white"
                        />
                        <path
                          d="M31.1372 28.4717H28.8443C28.4168 28.4717 28.0703 28.8183 28.0703 29.2457C28.0703 29.6731 28.4168 30.0197 28.8443 30.0197H31.1372C31.5646 30.0197 31.9112 29.6731 31.9112 29.2457C31.9112 28.8183 31.5646 28.4717 31.1372 28.4717Z"
                          fill="white"
                        />
                        <path
                          opacity="0.2"
                          d="M9.44102 42.8131C9.09357 43.2382 9.15536 43.8663 9.59449 44.1959C13.0008 46.7521 17.0314 48.3598 21.2745 48.8447C25.8473 49.3674 30.474 48.5642 34.603 46.5308C38.7321 44.4974 42.1894 41.3196 44.5628 37.3762C46.9363 33.4328 48.1257 28.89 47.9895 24.2895C47.8532 19.6889 46.397 15.2245 43.7943 11.4285C41.1916 7.63246 37.5523 4.66486 33.3102 2.87941C29.068 1.09395 24.4019 0.56596 19.8681 1.35836C15.6611 2.09363 11.7327 3.93696 8.48364 6.69036C8.06479 7.04532 8.04028 7.67598 8.41228 8.07977C8.78428 8.48357 9.41181 8.50743 9.83198 8.15404C12.7996 5.65815 16.379 3.9865 20.2104 3.31689C24.3686 2.59013 28.6482 3.07438 32.5389 4.71193C36.4296 6.34947 39.7674 9.07123 42.1545 12.5528C44.5416 16.0344 45.8772 20.1289 46.0021 24.3483C46.1271 28.5678 45.0362 32.7342 42.8594 36.3509C40.6825 39.9677 37.5117 42.8822 33.7247 44.7471C29.9377 46.6121 25.6943 47.3488 21.5003 46.8694C17.6361 46.4277 13.9639 44.9708 10.8538 42.655C10.4135 42.3271 9.78846 42.388 9.44102 42.8131Z"
                          fill="#3F8BBF"
                          stroke="#3F8BBF"
                          strokeOpacity="0.9"
                          strokeLinejoin="round"
                        />
                      </svg>
                    }
                    className={` ${
                      formData?.sailor ? "active_mode_btn_form" : "bg-white"
                    }`}
                  >
                    &nbsp;&nbsp;Sailor
                  </CustomButton>
                  {/* <CustomButton
                                        onClick={() =>
                                            setFormData({
                                                ...formData,
                                                captain: true,
                                                sailor: false,
                                            })}
                                        size={"large"}
                                        startIcon={
                                            <svg width="35" height="35" viewBox="0 0 49 50" fill="none">
                                                <path opacity="0.2" d="M9.44102 42.8131C9.09357 43.2382 9.15536 43.8663 9.59449 44.1959C13.0008 46.7521 17.0314 48.3598 21.2745 48.8447C25.8473 49.3674 30.474 48.5642 34.603 46.5308C38.7321 44.4974 42.1894 41.3196 44.5628 37.3762C46.9363 33.4328 48.1257 28.89 47.9895 24.2895C47.8532 19.6889 46.397 15.2245 43.7943 11.4285C41.1916 7.63246 37.5523 4.66486 33.3102 2.87941C29.068 1.09395 24.4019 0.56596 19.8681 1.35836C15.6611 2.09363 11.7327 3.93696 8.48364 6.69036C8.06479 7.04532 8.04028 7.67598 8.41228 8.07977C8.78428 8.48357 9.41181 8.50743 9.83198 8.15404C12.7996 5.65815 16.379 3.9865 20.2104 3.31689C24.3686 2.59013 28.6482 3.07438 32.5389 4.71193C36.4296 6.34947 39.7674 9.07123 42.1545 12.5528C44.5416 16.0344 45.8772 20.1289 46.0021 24.3483C46.1271 28.5678 45.0362 32.7342 42.8594 36.3509C40.6825 39.9677 37.5117 42.8822 33.7247 44.7471C29.9377 46.6121 25.6943 47.3488 21.5003 46.8694C17.6361 46.4277 13.9639 44.9708 10.8538 42.655C10.4135 42.3271 9.78846 42.388 9.44102 42.8131Z" fill="#92B9D5" stroke="white" strokeOpacity="0.9" strokeLinejoin="round" />
                                                <path d="M37.8177 24.2496C37.8177 21.7591 36.3021 19.184 33.6594 17.1846C30.945 15.131 27.4823 14 23.9089 14C20.3355 14 16.8727 15.131 14.1583 17.1846C11.5157 19.184 10 21.7591 10 24.2496V24.587L11.5805 26.104H36.3392L37.8177 24.5798V24.2496ZM23.9597 24.2731C22.1805 24.2731 20.7331 22.8256 20.7331 21.0465H22.3622C22.3622 21.63 22.6768 22.1412 23.1451 22.42V19.6482H22.0218V18.019H23.1451V16.6873H24.7743V18.019H25.8976V19.6482H24.7743V22.42C25.2426 22.1412 25.5572 21.63 25.5572 21.0465H27.1863C27.1863 22.8256 25.7389 24.2731 23.9597 24.2731Z" fill="#3F8BBF" />
                                                <path d="M12.668 27.7329H35.2278V29.4465H12.668V27.7329Z" fill="#3F8BBF" />
                                                <path d="M12.668 31.0757V31.1139L12.6896 32.0943C12.6896 34.2478 14.4402 35.9999 16.592 35.9999H31.3253C33.4771 35.9999 35.2277 34.2478 35.2277 32.0943V31.0757H12.668Z" fill="#3F8BBF" />
                                            </svg>
                                        }
                                        className={`${formData?.captain ? "active_mode_btn_form" : "bg-white"}`}
                                    >&nbsp;&nbsp;Captain</CustomButton> */}
                </div>
                {/* fields */}
                <div className="col-12 p-0 pt-2">
                  <div className="row m-0">
                    <div className="col-md-6">
                      <CustomInput
                        start_icon={<img src={profileIcon} alt="" />}
                        type="text"
                        name="first_name"
                        placeholder="First Name"
                        onChange={handleFormDetails}
                        value={formData.first_name}
                      />
                    </div>
                    <div className="col-md-6 ">
                      <CustomInput
                        type="text"
                        name="last_name"
                        placeholder="Last Name"
                        onChange={handleFormDetails}
                        value={formData.last_name}
                      />
                    </div>
                    <div className="col-12">
                      <CustomInput
                        start_icon={<img src={emailIcon} alt="" />}
                        type="email"
                        name="email"
                        placeholder="Email Address"
                        onChange={handleFormDetails}
                        value={formData.email}
                      />
                    </div>
                    <div className="col-12">
                      <CustomInput
                        start_icon={<img src={lockIcon} alt="" />}
                        type="password"
                        name="password"
                        onChange={handleFormDetails}
                        value={formData.password}
                        placeholder="Password"
                      />
                    </div>
                    <div className="col-12">
                      <CustomInput
                        start_icon={<img src={lockIcon} alt="" />}
                        type="password"
                        name="confirm_password"
                        onChange={handleFormDetails}
                        value={formData.confirm_password}
                        placeholder="Confirm Password"
                      />
                    </div>
                    <div className="col-12">
                      <CustomInput
                        onClick={() => setOpenCalendar((prev) => !prev)}
                        readOnly
                        start_icon={
                          <img
                            className="cursor-pointer"
                            onClick={() => setOpenCalendar((prev) => !prev)}
                            src={CalendarIcon}
                            alt=""
                          />
                        }
                        type="text"
                        name="date_of_birth"
                        value={
                          formData?.date_of_birth
                            ? Moment(
                                formData?.date_of_birth?.toString()
                              ).format("MMM Do YYYY")
                            : ""
                        }
                        placeholder="Date of Birth"
                      />
                      {formData?.date_of_birth?.toString()?.length > 0 &&
                        !underAgeValidate(formData.date_of_birth) && (
                          <span className="text-danger text-left mb-2 d-block">
                            Age should be 18 or greater.
                          </span>
                        )}
                    </div>
                    <div className="col-12">
                      <ReactFlagsSelect
                        searchable
                        className="cs_select"
                        searchPlaceholder="Search country"
                        placeholder="Choose Country"
                        selected={formData.nationality}
                        onSelect={(code) =>
                          setFormData({
                            ...formData,
                            nationality: code,
                          })
                        }
                      />
                    </div>
                    <div className="col-md-7 col-9 mx-auto pt-2">
                      <Button
                        className="siginin_form_btn mt-2 mb-2 text-white w-100"
                        type="submit"
                        disabled={
                          formData?.email?.length > 3 &&
                          formData?.password.length > 5 &&
                          formData?.confirm_password === formData.password &&
                          formData?.nationality.length > 1 &&
                          underAgeValidate(formData.date_of_birth)
                            ? loader
                            : true
                        }
                      >
                        Sign Up
                      </Button>
                    </div>
                    <div className="col-12 ">
                      <p className="py-2 text-muted">
                        Already have account?{" "}
                        <b
                          onClick={() => setShowPopup(!showPopup)}
                          className="text-sec cursor-pointer"
                        >
                          Sign in
                        </b>
                      </p>
                    </div>
                    {/* <div className="col-md-11 mx-auto">
                                            <div className="or_line">
                                                <hr />
                                                <span>OR</span>
                                                <hr />
                                            </div>
                                        </div> */}
                    {/* <div className="col-lg-10 mx-auto col-12">
                                            <div className="auth">
                                                <button type="button" className="auth_btn text-center d-flex justify-content-center">
                                                    <img src={googleIcon} alt="..." />&nbsp;&nbsp;&nbsp;
                                                    <span>Continue with Google</span>
                                                </button>
                                                <button type="button" className="auth_btn text-center d-flex justify-content-center">
                                                    <img src={fbIcon} alt="..." />
                                                    <span>Continue with Facebook</span>
                                                </button>
                                                <p className="text-muted">
                                                    Already have account?  <b onClick={() => setShowPopup(!showPopup)} className="text-sec cursor-pointer">Sign in</b>
                                                </p>
                                            </div>
                                        </div> */}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Paper>
      </div>

      {/* Calendar Model */}
      <CustomModel openPopup={openCalendar} setOpenPopup={setOpenCalendar}>
        <div className="date_menu cs_cal">
          <div className="intradaycalender">
            <Calendar
              onChange={(item) => {
                setFormData({
                  ...formData,
                  date_of_birth: item,
                });
                setOpenCalendar(false);
              }}
              date={formData.date_of_birth}
            />
          </div>
        </div>
      </CustomModel>
      {/* sign In form model */}
      <CustomModel openPopup={showPopup} setOpenPopup={setShowPopup}>
        <SiginInPopup closeModel={setShowPopup} />
      </CustomModel>
    </div>
  );
};

// Redux Configs
const mapStateToProps = (store) => ({
  current_user: store.current_user,
});

const mapDispatchToProps = (dispatch) => ({
  check_current_user: (token) => dispatch(check_current_user(token)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
